import * as R from 'ramda'

export const startDateTimeKey = 'startDateTime'
export const endDateTimeKey = 'endDateTime'

export const TYPE_SET_INITIAL = 'TYPE_SET_INITIAL'
export const TYPE_UPDATE_PARTIAL = 'TYPE_UPDATE_PARTIAL'

export const INIT_STATE = {
  [startDateTimeKey]: null,
  [endDateTimeKey]: null,
}

export const createVoucherAttributes = ({ startDateTime, endDateTime }) => {
  return R.mergeRight(INIT_STATE, {
    [startDateTimeKey]: startDateTime,
    [endDateTimeKey]: endDateTime,
  })
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TYPE_UPDATE_PARTIAL:
      return {
        ...state,
        [action.key]: action.value,
      }
    case TYPE_SET_INITIAL:
      return action.initialValue
    default:
      return state
  }
}
